import { useCallback, useState } from 'react';

import type { OilLogState } from '../types';

const initialState = (date: string): OilLogState => ({
  date,
  entries: [],
});

export function useOilLogForm(date: string) {
  const [state, setState] = useState<OilLogState>(() => initialState(date));
  const [logId, setLogId] = useState<string | null>(null);

  const prefillForm = useCallback((next: OilLogState, id: string | null) => {
    setState(next);
    setLogId(id);
  }, []);

  const resetForm = useCallback((resetDate: string) => {
    setState(initialState(resetDate));
    setLogId(null);
  }, []);

  return {
    state,
    logId,
    setState,
    setLogId,
    prefillForm,
    resetForm,
  };
}
